import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'custom-input-simple',
  templateUrl: './custom-input-simple.component.html',
  styleUrls: ['./custom-input-simple.component.css']
})
export class CustomInputSimpleComponent implements OnChanges {
  @Input() value : string = '';
  @Input() label : boolean = false;
  @Input() labelValue: string = '';
  @Input() placeholder: string = '';
  @Output() parentFunction = new EventEmitter<string>();
  @Output() valueChange = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.value = changes['value'].currentValue || '';
    }
  }

  onValueChange(newValue:any) {
    this.valueChange.emit(newValue)
  }

  onParentFunction(newValue:any) {
    this.parentFunction.emit(newValue.target.value)
  }
}
